import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);


// We intentionally DO NOT cache the app shell with a service worker.
// This app is loaded inside a WebView from the server, and precaching
// index.html caused stale builds (old code kept loading until reinstall).
// unregister() also removes any service worker installed by a previous
// build, so existing installs self-heal on the next launch.
// NOTE: this does not touch OneSignal's own worker (OneSignalSDKWorker.js),
// so push notifications keep working.
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
